/* eslint-disable jsx-a11y/label-has-associated-control */
import { isNull } from '@app/utils/is';
import { IconComponent, Linesheet } from '@typings';
import { useTranslation } from 'react-i18next';

import { GridViewTemplate } from './GridViewTemplate';
import { ListViewTemplate } from './ListViewTemplate';

interface TemplateMeta {
  itemsPerPage: number;
  placeholder: IconComponent;
}

export const enum LayoutType {
  GRID_9 = 'landscape-9',
  LIST_4 = 'portrait-4',
}

const TemplatesValues: Record<Linesheet.Template, TemplateMeta> = Object.freeze({
  [LayoutType.GRID_9]: {
    itemsPerPage: 9,
    placeholder: GridViewTemplate,
  },
  [LayoutType.LIST_4]: {
    itemsPerPage: 4,
    placeholder: ListViewTemplate,
  },
});

interface RadioProps {
  type: Linesheet.Template;
  templateName: string;
  coverUrl: Nullable<string>;
  inputId: string;
  describedById: string;
}

export const LayoutSampleRadioContent = ({ type, templateName, coverUrl, inputId, describedById }: RadioProps) => {
  const { itemsPerPage, placeholder: Placeholder } = TemplatesValues[type];
  const { t } = useTranslation(['linesheets']);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-y-4">
      <div className="flex h-28 w-28 flex-col items-center justify-center">
        {!isNull(coverUrl) ?
          <img className="h-20 w-28" alt={templateName} src={coverUrl} />
        : <Placeholder className="h-20 w-28" />}
      </div>
      <div className="flex flex-1 flex-col gap-y-2">
        <label htmlFor={inputId} className="line-clamp-2 flex-1 text-center body-6 absolute-cursor-pointer">
          {templateName}
        </label>
        <span id={describedById} className="text-center body-5">
          {t('linesheets:products_per_page', { count: itemsPerPage })}
        </span>
      </div>
    </div>
  );
};
